/* eslint-disable react-hooks/rules-of-hooks */
import { useMemo } from 'react';
import useDeliveryPassStatus from 'components/BookSlot/contexts/DeliveryPassStatus/useDeliveryPassStatus';
import { DeliveryPassStatusEnum } from 'components/BookSlot/contexts/DeliveryPassStatus/DeliveryPassStatusContext';
import {
  AUTHENTICATED_ACCOUNT,
  DELIVERY_PASS_ACTIVE,
  DELIVERY_PASS_AVAILABLE,
  LISTS,
} from 'constants/categoryIds';

export type Menu = {
  id: string;
  name: string;
  categoryIds: string[];
  url?: string;
  hasDescendants?: boolean;
};

const useMenusWithDeliveryPass = (menus: Menu[]) => {
  if (!menus || !Array.isArray(menus)) return [];

  const deliveryPassStatus = useDeliveryPassStatus();

  const menusWithDeliveryPass = useMemo(() => {
    if (
      [DeliveryPassStatusEnum.ACTIVE, DeliveryPassStatusEnum.AVAILABLE].includes(deliveryPassStatus)
    ) {
      const DELIVERY_PASS =
        deliveryPassStatus === DeliveryPassStatusEnum.ACTIVE
          ? DELIVERY_PASS_ACTIVE
          : DELIVERY_PASS_AVAILABLE;

      const authMenuIdx = menus.findIndex(m => m.id === AUTHENTICATED_ACCOUNT);

      if (authMenuIdx > -1) {
        const authMenu = menus[authMenuIdx];
        const { categoryIds } = authMenu;

        if (categoryIds.includes(DELIVERY_PASS)) {
          return menus;
        }

        const listsIdx = categoryIds.findIndex(id => id === LISTS);

        const updatedCategoryIds =
          listsIdx > -1
            ? [
                ...categoryIds.slice(0, listsIdx + 1),
                DELIVERY_PASS,
                ...categoryIds.slice(listsIdx + 1),
              ]
            : [...categoryIds, DELIVERY_PASS];

        return menus.map((menu, idx) =>
          idx === authMenuIdx ? { ...menu, categoryIds: updatedCategoryIds } : menu,
        );
      }
    }
    return menus;
  }, [deliveryPassStatus, menus]);

  return menusWithDeliveryPass;
};

export default useMenusWithDeliveryPass;
